import Intro from '../components/Intro'
import About from '../components/About'
import Services from '../components/Services'
import Experience from '../components/Experience';
import Recent from '../components/Recent'
import Contact from '../components/Contact'
function Landing() {
  return (
    <>
   
    <Intro />
    <About />
    <Services />
    <Experience/>
    <Recent />
    <Contact/>
    </>
  );
}

export default Landing;
